import React, { Component } from "react";
import { connect } from "react-redux";
import {fetchSingleCatagory, fetchSingleFlower, getSubCategoryFlowers, sortFlower, fetchAllCatagories} from "../../redux/actions";
import { Row, Col, FormGroup, FormControl } from "react-bootstrap";
import Header from "../decoration/header";
// import ProductPanel from "./productPanel";
// import RelatedProductsPanel from "./relatedProductsPanel";
import Footer from "../footer/footer";
import SingleCategoryPanel from '../singleCategory/singleCategoryPanel'
import "./singleItem.css";
import _ from 'lodash';

const searchBarStyle = {
	width: '20%'
}

class SingleItemWithSub extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      flowerData:[],
      categoryloading: true
    };
  }

  componentDidMount() {
    getSubCategoryFlowers(this.props.match.params.category, this.props.match.params.subcategory).then((res)=>{
      if(res && res.data) this.setState({flowerData:res.data, loading:false})
    })
    this.props.fetchAllCatagories()
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps !== this.props) {
      this.setState({
        categoryloading: false
      });
      console.log('List',this.props)
    }
  };

  handleSearchBarChange = event => {
    let userInputValue = event.target.value;
    if (userInputValue.length > 0) {
      this.props.fetchSingleFlower(userInputValue).then(response => {
        let responseData = response.payload.data;
        if (responseData !== undefined && responseData.length > 0) {
          this.setState({
            flowerData: responseData
          });

          if (this.props.pathname === "/category/all") {
            let searchBar = document.querySelector(".searchBar");
            searchBar.style.width = "35%";
          }
        }
      });
    }
  };

  handleDefaultSortingSelect = event => {
    this.setState({
      sortBy: event.target.value
    });
    const { category, subcategory } = this.props.match.params;
    // console.log(this.props.match.params.category);
    this.props.sortFlower(event.target.value, category,  subcategory).then(response => {
      let responseData = response.payload.data;
      console.log(responseData)
      if(responseData && responseData.length > 0){
        this.setState({
          flowerData: responseData,
          loading:false
        });
      }
    });
  };

  handleCategoriesSelect = event => {
    console.log('this props', this.props);
    this.setState({
      category: event.target.value
	});	
	window.location.href = `/category/${event.target.value}`;
  };

  renderOptions = () => {
    if (this.state.categoryloading === false) {
      return _.map(this.props.categoryList, (name, index) => {
        return <option key={index} value={name.name}>{name.name}</option>
      })      
    }
  }

  render() {
    const { category, subcategory } = this.props.match.params;
    let preservedFlowerBoxDiv = (
      <div className="AdvertiseBanner">
        {/* <h1 id="bannercaption">Preserved Flower Box</h1>
        <p id="bannerContentEg">
          Preserved flowers are created by Japanese innovative technology to
          maintain the freshness of flowers for up to 3 days (Duration of
          preserved flowers depends on humidity and the environment)
        </p> */}
        <p id="bannerContentCh" />

        <Row className="show-grid">
          <Col sm={6} md={6} >
            <FormGroup controlId="formControlsSelect">
              <FormControl
                componentClass="select"
                placeholder="select"
                onChange={event => this.handleDefaultSortingSelect(event)}
              >
                <option value="defaultSorting">Default sorting</option>
                <option value="newness">Sort by newness</option>
                <option value="priceLowToHigh">
                  Sort by price: low to high
                </option>
                <option value="priceHighToLow">
                  Sort by price: high to low
                </option>
              </FormControl>
            </FormGroup>
          </Col>
          <Col sm={6} md={6} >
            <FormGroup controlId="formControlsSelect">
              <FormControl
                componentClass="select"
                placeholder="select"
                onChange={event => this.handleCategoriesSelect(event)}
                value={this.props.catename || category}
              >{ !this.state.categoryloading && this.renderOptions()}
              </FormControl>
            </FormGroup>
          </Col>
        </Row>
      </div>
    );
    if (this.state.loading) {
      return <div>Loading...</div>;
    }
    else{
        //let sortBy = this.state.sortBy;
        // let category = this.state.category;
        return (
          <div id='blank'>
            <Header />
              <div className='space container'>
                <div className="searchBar" style={searchBarStyle}>
                  <span>
                    <i className="fa fa-search" aria-hidden="true" />
                  </span>
                  <input
                    id="searchBar"
                    type="text"
                    placeholder="Search"
                    onChange={event => this.handleSearchBarChange(event)}
                  />
                </div>
        
                {preservedFlowerBoxDiv}
                <SingleCategoryPanel flowerData={this.state.flowerData} catename={this.props.match.params.category} subcatname={this.props.match.params.subcategory||''}/>
              </div>
            <Footer />
          </div>
          
        );
    }
  }
}

function mapStateToProps(state, ownProps) {
  return {
    categoryList: state.catagorylist,
    currentCategory: state.singleCategory,
    singleItem: state.singleCategory[ownProps.match.params.id]

  };
}

export default connect(
  mapStateToProps,
  { getSubCategoryFlowers, fetchSingleCatagory, fetchSingleFlower, sortFlower, fetchAllCatagories  }
)(SingleItemWithSub);



// WEBPACK FOOTER //
// ./src/components/singleItem/singleItemWithSubCat.js